/**
 * @generated SignedSource<<6060cdd043024820263f6d14cbe9f928>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditAccomodationPrices_package$data = {
  readonly cateringOptions: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly rooms: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesEditorInit_package" | "RoomRatesTable_package" | "RoomRatesToolbar_package">;
  readonly " $fragmentType": "PackageEditAccomodationPrices_package";
};
export type PackageEditAccomodationPrices_package$key = {
  readonly " $data"?: PackageEditAccomodationPrices_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditAccomodationPrices_package">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditAccomodationPrices_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CateringOption",
      "kind": "LinkedField",
      "name": "cateringOptions",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Room",
      "kind": "LinkedField",
      "name": "rooms",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesTable_package"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesEditorInit_package"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesToolbar_package"
    }
  ],
  "type": "Package",
  "abstractKey": null
};
})();

(node as any).hash = "ca6c7eb786428bebd36d175c7cf2d06c";

export default node;
